/**
 * Photo filename handling for report documents.
 *
 * Photos are keyed by BASENAME everywhere (the manifest maps
 * "photo_01.jpeg" -> URL), but the names inside a report can arrive dirty:
 * LLMs wrap filenames in markdown or quotes ("`photo_01.jpeg`"), and stored
 * paths may be the worker's temp directory. A dirty name silently resolves to
 * no photo — a placeholder frame with no error — so every lookup normalizes
 * first. The worker heals stored documents too; this keeps already-saved
 * reports displaying correctly right now, without waiting for a re-render.
 */

/**
 * Reduce any stored photo reference to its bare manifest key.
 * @param {unknown} raw
 * @returns {string}
 */
export const cleanPhotoName = (raw) => {
  const stripped = String(raw || "")
    .trim()
    .replace(/^[`'"*_\s-•]+/, "")
    .replace(/[`'"*_\s]+$/, "");
  const base = stripped.replace(/\\/g, "/").split("/").pop() || "";
  return base.replace(/^[`'"*\s]+|[`'"*\s]+$/g, "");
};

/**
 * Resolve a stored photo reference to a browser URL via the manifest.
 * @param {Record<string, string> | null | undefined} manifest
 * @param {unknown} raw
 * @returns {string | null}
 */
export const photoUrlFromManifest = (manifest, raw) => manifest?.[cleanPhotoName(raw)] || null;
